import useSanityClient from '@/clients/sanity/'
import { productFragment } from '@/clients/sanity/queries/fragments/pages/product'
import type { CMSPageSlug, CMSProductPage } from '@/types/sanity'

export const productQuery = (
  slug: string,
) => `*[_type == "product" && store.slug.current == "${slug}" && store.isDeleted == false && store.status == "active"][0] {
  ${productFragment}
}`

export const baseProductQuery = (
  slug: string,
) => `*[_type == "product" && store.slug.current == "${slug}" && store.isDeleted == false && store.status == "active"][0] {
  _id
}`

const getAllProductSlugsQuery = (
  cursor: string | null,
  limit: number,
) => `*[_type == "product" && store.isDeleted == false && store.status == "active" && config.active == true && _id > "${cursor}"] | order(_id) [0...${limit}] {
  _id,
  "slug": store.slug.current
}`

export const getFlagVariantBySKUQuery = (
  sku: string[],
  ids: string[],
) => `*[_type == "productVariant" && store.gid in ${JSON.stringify(
  ids,
)} && store.sku in ${JSON.stringify(
  sku,
)} && store.isDeleted == false && store.status == "active"] {
  store {
    sku
  },
  userLoggedInRequired
}`

export const getAllProductSlugs = async (): Promise<CMSPageSlug[]> => {
  let cursorId: string | null = ''
  let limit = 50
  let response: CMSPageSlug[] = []

  const getProductSlugs = async (): Promise<CMSPageSlug[]> => {
    if (cursorId === null) {
      return response
    }

    const result = await useSanityClient.fetch(
      getAllProductSlugsQuery(cursorId, limit),
    )

    if (result?.length > 0) {
      cursorId = result[result.length - 1]._id
    } else {
      cursorId = null
    }

    response = response.concat(result || [])

    return await getProductSlugs()
  }

  const res = await getProductSlugs()

  return res.flat()
}

export const getProduct = async (slug: string): Promise<CMSProductPage> => {
  const res = await useSanityClient.fetch(productQuery(slug))

  return res
}

export const getFlagVariantBySKU = async (
  sku: string[],
  ids: string[],
): Promise<any> => {
  const res = await useSanityClient.fetch(getFlagVariantBySKUQuery(sku, ids))

  return res
}
